// extracted by mini-css-extract-plugin
export default {"BooleanFeature":"vw_a bhi_b"};